















import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import BaseTitle from "./base-title.vue";
export interface IOrderInformation {
  [key: string]: string;
}
@Component({
  components: {
    BaseTitle
  }
})
export default class OrderInformation extends Vue {
  @Prop({ default: () => [] }) informations!: Array<IOrderInformation>;
  @Prop(String) title!: string;
  @Prop(String) icon!: string;
}
